(function($) {
  jQuery(document).ready(function() {
    // Add address to first textarea on property inquiry form
    var inquiryForm = $('.widget-inquiry form, #propertyInquiryForm form');
    if (inquiryForm.length > 0) {
      if (!$(inquiryForm).find('textarea:first').val()) {
        var propertyAddress;
        if ($('.property-address-full').length > 0) {
        propertyAddress = $('.property-address-full').html();
        }

        if ($('.ihf-address').length > 0) {
        propertyAddress = $('.ihf-address').html();
        }

        propertyAddress = propertyAddress.replace(/<br\s*\/?>/gi, ' ');
        $(inquiryForm).find('textarea:first').val('I am interested in ' + propertyAddress);
      }
    }
    $('.slider-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.slider-nav',
      useCSS: false,
      useTransform: false
    });
    $('.slider-nav').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.slider-for',
      arrows: true,
      prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="24" height="24" fill="#aaa"><path d="M20 1 L24 5 L14 16 L24 27 L20 31 L6 16 z"></path></svg></button>',
      nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="24" height="24" fill="#aaa"><path d="M12 1 L26 16 L12 31 L8 27 L18 16 L8 5 z"></path></svg></button>',
      focusOnSelect: true,
      useCSS: false,
      useTransform: false
    });
  });
})(jQuery);


// WEBPACK FOOTER //
// ./assets/scripts/property.js